export function request(userId, betUid, data) {
    console.info('updateBet userId, betUid, data', {userId, betUid, data});

    return {
        type: 'BETSLIP_UPDATE_BET',
        userId,
        betUid,
        data
    };
}
